import React, { Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import {
  checkMobilePhone,
  normalizeMobilePhone,
  toEN,
} from '../../../../../fns';
import { useSearchParams } from 'hooks/useSearchParams';
import { Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';

const DriversFilters = () => {
  const [params, setParams] = useSearchParams();
  const { register, handleSubmit } = useForm();

  const handleChange = ({ firstName, mobilePhone }) => {
    setParams([
      { name: 'page', value: 1 },
      { name: 'firstName', value: firstName },
      {
        name: 'mobilePhone',
        value: checkMobilePhone(mobilePhone)
          ? checkMobilePhone(toEN(mobilePhone))
          : normalizeMobilePhone(toEN(mobilePhone)),
      },
    ]);
  };

  return (
    <form onSubmit={handleSubmit(handleChange)}>
      <Fragment>
        <TextField
          className="ms-2"
          {...register('firstName')}
          size="small"
          label="فیلتر نام"
          name="firstName"
          variant="outlined"
          defaultValue={params.get('firstName')}
        />
        <TextField
          className="ms-2"
          {...register('mobilePhone')}
          size="small"
          label="فیلتر موبایل"
          name="mobilePhone"
          variant="outlined"
          defaultValue={params.get('mobilePhone')}
        />
        <Button type="submit" variant="contained" color="secondary">
          جستجو
        </Button>
      </Fragment>
    </form>
  );
};

export default React.memo(DriversFilters);

